import { render } from "./ClientDashboard.vue?vue&type=template&id=72340fd4&scoped=true"
import script from "./ClientDashboard.vue?vue&type=script&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&lang=js"

import "./ClientDashboard.vue?vue&type=style&index=0&id=72340fd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72340fd4"]])

export default __exports__